import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { SalesReport } from './models/sales-report';
import { SalesReportFilters } from './models/sales-report-filters';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class SalesReportService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {}

  getSales(cnpj: string, reportFilters: SalesReportFilters): Observable<SalesReport[]> {
    if (cnpj === '') {
      return of([]);
    }

    const body = {
      equipes: reportFilters.teams,
      vendedores: reportFilters.sellers.map(seller => seller.codigo_externo),
      planos: reportFilters.plans.map(plan => plan.codigo),
      data_da_criacao_app: {
        De: reportFilters.salePeriod.fromDate ? moment(reportFilters.salePeriod.fromDate).format('YYYY-MM-DD') : null,
        Ate: reportFilters.salePeriod.toDate ? moment(reportFilters.salePeriod.toDate).format('YYYY-MM-DD') : null,
      },
      createdAt: {
        De: reportFilters.syncAppPanelPeriod.fromDate
          ? moment(reportFilters.syncAppPanelPeriod.fromDate).format('YYYY-MM-DD')
          : null,
        Ate: reportFilters.syncAppPanelPeriod.toDate
          ? moment(reportFilters.syncAppPanelPeriod.toDate).format('YYYY-MM-DD')
          : null,
      },
      datahora_aprovacao: {
        De: reportFilters.approvalPeriod.fromDate
          ? moment(reportFilters.approvalPeriod.fromDate).format('YYYY-MM-DD')
          : null,
        Ate: reportFilters.approvalPeriod.toDate
          ? moment(reportFilters.approvalPeriod.toDate).format('YYYY-MM-DD')
          : null,
      },
      datahora_sincronismo_erp: {
        De: reportFilters.syncErpPeriod.fromDate
          ? moment(reportFilters.syncErpPeriod.fromDate).format('YYYY-MM-DD')
          : null,
        Ate: reportFilters.syncErpPeriod.toDate
          ? moment(reportFilters.syncErpPeriod.toDate).format('YYYY-MM-DD')
          : null,
      },
    };

    return this.http
      .post<SalesReport[]>(`${environment.vendas}/salesreport/${cnpj}`, body, this.httpOptions)
      .pipe(catchError(err => of(err.error)));
  }

  exportToCSV(cnpj: string, reportFilters: SalesReportFilters) {
    if (cnpj === '') {
      return of();
    }

    const body = {
      exportToCSV: true,
      equipes: reportFilters.teams,
      vendedores: reportFilters.sellers.map(seller => seller.codigo_externo),
      planos: reportFilters.plans.map(plan => plan.codigo),
      data_da_criacao_app: {
        De: reportFilters.salePeriod.fromDate ? moment(reportFilters.salePeriod.fromDate).format('YYYY-MM-DD') : null,
        Ate: reportFilters.salePeriod.toDate ? moment(reportFilters.salePeriod.toDate).format('YYYY-MM-DD') : null,
      },
      createdAt: {
        De: reportFilters.syncAppPanelPeriod.fromDate
          ? moment(reportFilters.syncAppPanelPeriod.fromDate).format('YYYY-MM-DD')
          : null,
        Ate: reportFilters.syncAppPanelPeriod.toDate
          ? moment(reportFilters.syncAppPanelPeriod.toDate).format('YYYY-MM-DD')
          : null,
      },
      datahora_aprovacao: {
        De: reportFilters.approvalPeriod.fromDate
          ? moment(reportFilters.approvalPeriod.fromDate).format('YYYY-MM-DD')
          : null,
        Ate: reportFilters.approvalPeriod.toDate
          ? moment(reportFilters.approvalPeriod.toDate).format('YYYY-MM-DD')
          : null,
      },
      datahora_sincronismo_erp: {
        De: reportFilters.syncErpPeriod.fromDate
          ? moment(reportFilters.syncErpPeriod.fromDate).format('YYYY-MM-DD')
          : null,
        Ate: reportFilters.syncErpPeriod.toDate
          ? moment(reportFilters.syncErpPeriod.toDate).format('YYYY-MM-DD')
          : null,
      },
    };

    return this.http
      .post(`${environment.vendas}/salesreport/${cnpj}`, body, {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        responseType: 'blob',
      })
      .pipe(catchError(err => of(err.error)));
  }
}
